module.exports = __webpack_public_path__ + "img/avatar.da32f0b3.svg";